import { Validator } from '@vista-digital/validator';
import { defaultMemberBalanceConfig, memberBalanceConfigValidator } from './config';
import { defaultMemberBalanceDisplayText, memberBalanceDisplayTextValidator } from './display-text';
export const memberBalancePropsValidator = Validator.object({
    config: memberBalanceConfigValidator,
    displayText: memberBalanceDisplayTextValidator
});
export const defaultMemberBalanceProps = {
    config: defaultMemberBalanceConfig,
    displayText: defaultMemberBalanceDisplayText
};
